import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react';
import { GlobalSearch } from './GlobalSearch';
import { useAuth } from '../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const ROLE_NAMES = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  account_manager: 'Account Manager',
  operator: 'Operator',
  support_operator: 'Support',
  customer: 'Customer',
  carrier: 'Carrier',
};

const Navbar = ({ onToggleSidebar, sidebarOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const initials = (user?.name || 'U')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="nui-navbar" data-testid="top-navbar">
      <button
        className="nui-sidebar-toggler"
        onClick={onToggleSidebar}
        aria-label="Toggle navigation menu"
        aria-expanded={sidebarOpen}
        data-testid="mobile-menu-toggle"
      >
        <Menu />
      </button>
      <div className="nui-navbar-content">
        <GlobalSearch />
        <div className="nui-navbar-right">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="nui-profile-btn" aria-label="Account menu" data-testid="navbar-profile-button">
                <span className="nui-avatar">{initials}</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-60">
              <DropdownMenuLabel>
                <p className="text-sm font-semibold text-[var(--tms-text)]" data-testid="navbar-user-name">{user?.name}</p>
                <p className="text-xs font-normal text-[var(--tms-text-muted)]">{user?.email}</p>
                <span className="inline-block mt-1 px-2 py-0.5 text-[11px] rounded bg-[#F8191B]/10 text-[#F8191B] border border-[#F8191B]/30" data-testid="navbar-user-role">
                  {ROLE_NAMES[user?.role] || 'User'}
                </span>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout} className="cursor-pointer" data-testid="logout-button">
                <LogOut className="w-4 h-4 mr-2" />
                Log Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
